import {
  useState,
} from 'react';

const useModal = () => {
  const [isOpen, setOpen] = useState(false);

  const open = () => {
    setOpen(true);
  };

  const close = () => {
    setOpen(false);
  };

  const toggle = () => {
    setOpen(!isOpen);
  };

  const onClose = close;

  return {
    isOpen,
    open,
    close,
    toggle,
    onClose,
  };
};

export default useModal;
